import styles from './index.module.less'
import ModuleAccountTrading from '../cardInfoOne'
import { ModuleTransfer } from '@/api/blocks/interface'
import MeEmpty from '@/components/MeEmpty'
import LoadingCom from '@/components/LoadingCom'
import classNames from 'classnames'

const ModuleAccountTradingList = ({
  moduleTransfers,
  loading,
}: {
  moduleTransfers: ModuleTransfer[]
  loading: boolean
}) => {
  return (
    <div className={styles.wrap}>
      {loading ? <LoadingCom></LoadingCom> : null}
      {moduleTransfers.length === 0 && (
        <div
          className={classNames({
            [styles.emptyLoading]: loading,
          })}
        >
          <MeEmpty />
        </div>
      )}
      {moduleTransfers?.map((item, index) => (
        <ModuleAccountTrading
          key={`${item.id}${index}`}
          moduleTransfer={item}
        ></ModuleAccountTrading>
      ))}
    </div>
  )
}

export default ModuleAccountTradingList
